import { Component } from 'react';

class RequestsSent extends Component {
  render() {
    return (
      <div className="status-block">
        <div className="status-block__status spec-requests-sent">
          {this.props.value}
        </div>
        <div className="status-block__title">{this.props.label}</div>
      </div>
    );
  }
}

export default RequestsSent;
